import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const UserSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  style = undefined,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      style={style}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.46453 16.1113C5.40221 15.1344 6.67398 14.5856 8.00006 14.5856H16.0001C17.3261 14.5856 18.5979 15.1344 19.5356 16.1113C20.4733 17.0882 21.0001 18.4132 21.0001 19.7947V21.8784C21.0001 22.4537 20.5523 22.9202 20.0001 22.9202C19.4478 22.9202 19.0001 22.4537 19.0001 21.8784V19.7947C19.0001 18.9658 18.684 18.1708 18.1214 17.5847C17.5588 16.9985 16.7957 16.6692 16.0001 16.6692H8.00006C7.20441 16.6692 6.44135 16.9985 5.87874 17.5847C5.31613 18.1708 5.00006 18.9658 5.00006 19.7947V21.8784C5.00006 22.4537 4.55235 22.9202 4.00006 22.9202C3.44778 22.9202 3.00006 22.4537 3.00006 21.8784V19.7947C3.00006 18.4132 3.52685 17.0882 4.46453 16.1113Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 4.16727C10.3432 4.16727 9.00006 5.5666 9.00006 7.29276C9.00006 9.01891 10.3432 10.4182 12.0001 10.4182C13.6569 10.4182 15.0001 9.01891 15.0001 7.29276C15.0001 5.5666 13.6569 4.16727 12.0001 4.16727ZM7.00006 7.29276C7.00006 4.41583 9.23864 2.08362 12.0001 2.08362C14.7615 2.08362 17.0001 4.41583 17.0001 7.29276C17.0001 10.1697 14.7615 12.5019 12.0001 12.5019C9.23864 12.5019 7.00006 10.1697 7.00006 7.29276Z"
        fill={color}
      />
    </svg>
  );
};

export { UserSvg };
